import { reportErrorToSentry } from 'app/config/configSentry';
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary: ', error, info);

    try {
      // Usar la función helper para reportar el error
      const eventId = reportErrorToSentry(error, {
        componentStack: info.componentStack,
        errorBoundary: 'ErrorBoundary',
        url: window.location.href,
        timestamp: new Date().toISOString(),
      });

      if (eventId) {
        console.log('Error reportado a Sentry con ID:', eventId);
      }
    } catch (sentryError) {
      console.error('ErrorBoundary: Error al reportar a Sentry:', sentryError);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
